/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type VerificationCodeVerifyVariables = Types.Exact<{
  phone: Types.Scalars['String']
  code: Types.Scalars['String']
}>

export type VerificationCodeVerify = {
  __typename: 'Root'
  verificationCodeVerify: {
    __typename: 'VerificationCodeVerifyPayload'
    phoneToken: string | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const VerificationCodeVerifyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerificationCodeVerify' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phone' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationCodeVerify' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phone' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'code' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'phoneToken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type VerificationCodeVerifyMutationFn = Apollo.MutationFunction<
  VerificationCodeVerify,
  VerificationCodeVerifyVariables
>

/**
 * __useVerificationCodeVerify__
 *
 * To run a mutation, you first call `useVerificationCodeVerify` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerificationCodeVerify` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verificationCodeVerify, { data, loading, error }] = useVerificationCodeVerify({
 *   variables: {
 *      phone: // value for 'phone'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerificationCodeVerify(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerificationCodeVerify,
    VerificationCodeVerifyVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    VerificationCodeVerify,
    VerificationCodeVerifyVariables
  >(VerificationCodeVerifyDocument, options)
}
export type VerificationCodeVerifyHookResult = ReturnType<
  typeof useVerificationCodeVerify
>
export type VerificationCodeVerifyMutationResult =
  Apollo.MutationResult<VerificationCodeVerify>
export type VerificationCodeVerifyMutationOptions = Apollo.BaseMutationOptions<
  VerificationCodeVerify,
  VerificationCodeVerifyVariables
>
